import { IForm } from '@/components/types'
import { useSearchDateShortcut } from '@/hooks/useSearch'
const shortcuts = useSearchDateShortcut()

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'deptId',
      type: 'select',
      label: '部门',
      placeholder: '请选择部门'
    },
    {
      field: 'title',
      type: 'input',
      label: '素材标题',
      placeholder: '请输入素材标题'
    },
    {
      field: 'accessTime',
      type: 'datepicker',
      label: '访问时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    }
  ]
}
